"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Options = _interopRequireDefault(require("../Dropdown/Options"));

var _List = _interopRequireDefault(require("../List"));

require("./styles.css");

var _common = require("../../common");

var _lib = require("../../lib");

var _constants = require("../../constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var TimePickerOptions =
/*#__PURE__*/
function (_Component) {
  _inherits(TimePickerOptions, _Component);

  function TimePickerOptions() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, TimePickerOptions);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(TimePickerOptions)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "classNames", function () {
      // TODO: change to make it auto detect.
      var names = [TimePickerOptions.className, _Options.default.className, 'direction-bottom'];
      return names.join(' ');
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnChange", function (e, _ref, name) {
      var value = _ref.value;
      var onChange = _this.props.onChange;

      if (onChange) {
        onChange(e, {
          name: name,
          value: value
        });
      }
    });

    return _this;
  }

  _createClass(TimePickerOptions, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          visible = _this$props.visible,
          hourRef = _this$props.hourRef,
          minuteRef = _this$props.minuteRef,
          hourOptions = _this$props.hourOptions,
          minuteOptions = _this$props.minuteOptions,
          ampmOptions = _this$props.ampmOptions,
          isHourSelected = _this$props.isHourSelected,
          isMinuteSelected = _this$props.isMinuteSelected,
          isAMPMSelected = _this$props.isAMPMSelected,
          onModeChange = _this$props.onModeChange;
      var classNames = this.classNames();
      if (!visible) return null; // pass options as props to trigger rerender

      return _react.default.createElement(_List.default, {
        className: classNames,
        horizontal: true
      }, _react.default.createElement(_List.default.Item, {
        className: "columns"
      }, _react.default.createElement(_Options.default, {
        innerRef: hourRef,
        textAlign: "center",
        className: "options",
        visible: true,
        options: hourOptions,
        onChange: function onChange(e, d) {
          return _this2.handleOnChange(e, d, 'hour');
        },
        isItemSelected: isHourSelected
      })), _react.default.createElement(_List.default.Item, {
        className: "columns"
      }, _react.default.createElement(_Options.default, {
        innerRef: minuteRef,
        textAlign: "center",
        className: "options",
        visible: true,
        options: minuteOptions,
        onChange: function onChange(e, d) {
          return _this2.handleOnChange(e, d, 'minute');
        },
        isItemSelected: isMinuteSelected
      })), (0, _lib.arrayHasItems)(ampmOptions) ? _react.default.createElement(_List.default.Item, {
        className: "columns"
      }, _react.default.createElement(_Options.default, {
        textAlign: "center",
        className: "options",
        visible: true,
        options: ampmOptions,
        onChange: onModeChange,
        isItemSelected: isAMPMSelected
      })) : null);
    }
  }]);

  return TimePickerOptions;
}(_react.Component);

exports.default = TimePickerOptions;

_defineProperty(TimePickerOptions, "className", 'MHub-TimePicker-Options');

_defineProperty(TimePickerOptions, "propTypes", {
  visible: _propTypes.default.bool,
  onChange: _propTypes.default.func,
  onModeChange: _propTypes.default.func,
  isHourSelected: _propTypes.default.func,
  isMinuteSelected: _propTypes.default.func,
  isAMPMSelected: _propTypes.default.func,
  hourRef: _common.customPropTypes.ref,
  minuteRef: _common.customPropTypes.ref,
  hourOptions: _common.customPropTypes.dropdownOption,
  minuteOptions: _common.customPropTypes.dropdownOption,
  ampmOptions: _common.customPropTypes.dropdownOption
});

_defineProperty(TimePickerOptions, "defaultProps", {
  visible: false,
  onChange: null,
  onModeChange: null,
  isHourSelected: null,
  isMinuteSelected: null,
  isAMPMSelected: null,
  hourRef: null,
  minuteRef: null,
  hourOptions: _constants.hour,
  minuteOptions: _constants.minute,
  ampmOptions: _constants.ampm
});